import axios from "axios";

export const state = {
    homeworks: [],
};

export const getters = {
    homeworks: state => state.homeworks,
};

export const mutations = {
    setHomeworks(state, newValue) {
        state.homeworks = newValue
    },
};

export const actions = {
    fetchHomeworks({ commit }) {
        axios.get('/homeworks').then(res => {
            commit('setHomeworks', res.data.homeworks)
        })
    },
    filterHomework({commit}, {schoolterm,year}) { 
        let formData = new FormData();
        formData.append("schoolterm", schoolterm);
        formData.append("year", year);
        let url = "/filterhomework";
        axios.post(url, formData).then((response) => {
            commit('setHomeworks', response.data.homeworks)
        })
    },
};
